// @flow
import * as React from 'react';
import useTitle from '@/hook/useTitle';
import {LeftOutlined} from '@ant-design/icons';
import _ from 'lodash';
import Search from 'antd/es/input/Search';
import {useState} from 'react';
import {message} from 'antd';
import './travelInfSendPage.less';
import abbvimg from './abbv.png';
import {sendJourneies} from '@/api/travel';

export default function TravelInfSendPage() {
    useTitle('年会信息管理');
    const [userName, setUserName] = useState(null);
    let direction;

    function onSearch(e) {
        const name = e.trim();
        if (_.isEmpty(name)) {
            message.warning('请输入姓名');
            setUserName('');
        } else {
            setUserName(name);
            console.log(userName, name);
            sendJourneies(name).then(data => {
                console.log(data);
                if (data.status == 200) {
                    message.success(`${name}的航班信息发送成功`);
                }

            });
        }
    }

    return (
        <div className={'sendPage'}>
            <div className={'head'}>
                <LeftOutlined className={'heacIcon'} />
                <div className={'headTitle'}>
                    年会信息管理
                </div>
            </div>
            <div className={'centerLogo'}>
                <img src={abbvimg} alt="abbv" />
                <span>年会信息管理</span>
            </div>
            <div className={'floatSearch'}>
                <Search
                    placeholder="请输入乘坐航班人员姓名"
                    allowClear
                    enterButton="发送"
                    size="large"
                    onSearch={onSearch}
                    style={{margin: '0 5px'}}
                    bordered
                />
            </div>
        </div>
    );
}
